import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const Modal = ({ visible, children, className, classNames = {} }) => {
  if (!visible) return null;

  const modalCustomClassName = className || classNames['modal'];
  const modalContainerCustomClassName = classNames['container'];

  return ReactDom.createPortal(
    <div className={clsx('modal', modalCustomClassName)}>
      <div
        className={clsx(['modal__container', modalContainerCustomClassName])}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Modal;
